export default __webpack_public_path__ + "static/media/fontRoboto400_latin_ext.861b791f.woff2";